import { render } from "./PatientsManagement.vue?vue&type=template&id=93795050&scoped=true"
import script from "./PatientsManagement.vue?vue&type=script&lang=js"
export * from "./PatientsManagement.vue?vue&type=script&lang=js"

import "./PatientsManagement.vue?vue&type=style&index=0&id=93795050&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93795050"]])

export default __exports__